const consultingbooking = {
    getlist: 'consultingbooking/getlist-by-admin',
    get: 'consultingbooking/get-by-admin',
}
export default consultingbooking
